import cacheAppIcons from './cache-icons.run.js';

export default angular.module('appAppSwitcher', [
])
  .run(cacheAppIcons)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/mini-apps/app-switcher/app-switcher.module.js